import Reveal from "reveal.js";
import { createSlide } from "../../slidesOps/createSlide";
import { autoLoopMapHighlights } from "./autoLoopMapHighlights";
import { sortByProp } from "../../../../utilities/sortByProp";
import { resetMap } from "./resetMap";
import { getMapInterval } from "./mapInterval";
import { dataOn } from "../../data/data";
import BuildingMapSVG from "../../../../icons/buildingMap.svg";
// TODO: add temporary override of map locations?
export const slideMapID = "map";
export function slideMap() {
    Reveal.on("slidechanged", (event) => {
        if (event.currentSlide.id === slideMapID) {
            autoLoopMapHighlights();
        }
        else if (getMapInterval()) {
            resetMap();
        }
    });
    dataOn(`bible-classes`, (rooms) => {
        // listen for changes for if room data changes
        // this is so we can make last minute changes on the fly quickly.
        const title = rooms.title;
        const contentElement = document.querySelector(".map-content");
        const reverseOrder = rooms.order.reverse;
        const sortClassBy = {
            ["name" /* RoomOrderBy.Name */]: sortByProp("name" /* RoomOrderBy.Name */, reverseOrder),
            ["id" /* RoomOrderBy.ID */]: sortByProp("id" /* RoomOrderBy.ID */, reverseOrder),
            ["ageOrder" /* RoomOrderBy.Age */]: sortByProp("ageOrder" /* RoomOrderBy.Age */, reverseOrder),
            ["order" /* RoomOrderBy.Order */]: sortByProp("order" /* RoomOrderBy.Order */, reverseOrder),
        };
        let leftCol = `<ul class="numbered-rooms left">`;
        let rightCol = `<ul class="numbered-rooms right">`;
        rooms.numbered = rooms.numbered
            .filter((d) => d.active) // remove inactive rooms
            .sort(sortClassBy[rooms.order.by || "ageOrder" /* RoomOrderBy.Age */]); // order by configuration // id by default
        if (rooms.auditorium.active) {
            rooms.numbered.unshift(rooms.auditorium); // put auditorium first in the list
        }
        for (let i = 0, l = rooms.numbered.length; i < l; i++) {
            const room = rooms.numbered[i];
            const roomIndex = i; // room.id.split('-')[1];
            const item = `
        <li class="room" data-id="${room.id}" data-order="${roomIndex || 0}">
            <p class="room-id">${room.id.split("-")[1] || "--"}</p>
            <div class="room-content">
                <p class="room-name">${room.name}</p>
                ${room.description
                ? '<p class="room-desc">' + room.description + "</p>"
                : ""}
            </div>
        </li>
      `;
            if (i % 2) {
                rightCol += item;
            }
            else {
                leftCol += item;
            }
        }
        leftCol += `</ul>`;
        rightCol += `</ul>`;
        contentElement.innerHTML = `
        <h4 class="main-title">${title.svg || title.text}</h4>
        <div class="map-content-container">
            ${leftCol}
            ${rightCol}
        </div>
        <footer class="map-content-footer">
            <ul class="map-content-footer-container">
                <li>
                    <img src="https://www.cedarparkchurchofchrist.org/media/uploads/src/board/icon-youhere.svg" />
                    You are here
                </li>
                <li class="room ${rooms.restrooms.id}" data-id="${rooms.restrooms.id}" data-order="1000">
                    <img src="https://www.cedarparkchurchofchrist.org/media/uploads/src/board/icon-restroom.svg" class="inverse-hover" />
                    ${rooms.restrooms.name}
                </li>
                <li class="room" data-id="${rooms.nursery.id}" data-order="1001">
                    <img src="https://www.cedarparkchurchofchrist.org/media/uploads/src/board/icon-baby.svg" class="inverse-hover" />
                    ${rooms.nursery.name}
                </li>
            </ul>
        </footer>
    `;
        // we have to start everything again if data was updated
        // includes clearing the interval
        if (Reveal.getCurrentSlide().id === slideMapID) {
            // only restart interval if we're on the correct slide
            autoLoopMapHighlights();
        }
    });
    const html = `
    <style>
        #map {
            --map-overlay-end: rgb(68, 148, 221);
            --map-overlay-start: rgba(68, 148, 221, .25);
        }

        .building-map {
            height: 100%;
            width: 100%;
            display: block;
        }

        .building-map .overlay {
            opacity: 0;
            fill: url(#map-overlay-gradient);
            transition: opacity .4s .2s ease-in-out;
        }

        .building-map .active .overlay {
            opacity: 1;
        }

        .map-content .map-content-container {
            display: flex;
        }

        .map-content .main-title {
            margin-bottom: 1em;
            text-align: left;
        }

        .map-content .main-title svg {
            max-width: 70%;
            margin-left: -16px;
        }

        .map-content .main-title svg .cls-2 {
            fill: #7B807A;
        }

        .map-content .main-title svg .cls-1 {
            fill: #306799;
        }

        .map-content .numbered-rooms {
            padding: 0;
            margin: 0;
            list-style-type: none;
            width: 50%;
            margin-right: 40px;
        }

        .map-content .numbered-rooms.right {
            margin-top: 1em;
            margin-right: 0;
        }

        .map-content .room {
            display: flex;
            margin-bottom: .7em;
            margin-bottom: .575em;
            position: relative;
            transition: color .2s ease-in-out;
        }

        .map-content .room.active {
            color: #fff;
        }

        .map-content .room::before {
            content: '';
            background: #7b807a linear-gradient(315deg, var(--map-overlay-end) -25%, var(--map-overlay-start) 100%);
            height: 100%;
            width: 100%;
            position: absolute;
            z-index: 1;
            opacity: 0;
            padding: 8px 16px;
            left: -16px;
            top: -8px;
            border: 2px solid transparent;
            transition: opacity .4s ease-in-out;
            z-index: -1;
            border-radius: 10px;
        }

        .map-content .room.active::before {
            opacity: 1;
        }

        .map-content .room-id {
            margin: 0;
            margin-right: 20px;
            font-weight: 100;
            font-size: 1.25em;
            min-width: 63px;
            text-align: center;
            opacity: .5;
            margin-top: -0.2em;
        }

        .map-content .room-name {
            margin: 0 0 .3em;
            font-weight: 700;
            font-size: .65em;
        }

        .map-content .room-desc {
            margin: 0;
            font-size: 30px;
            font-weight: 300;
            font-size: .4em;
            min-height: 43px;
        }

        .map-content .map-content-footer-container {
            list-style-type: none;
            margin: 0;
            padding: 0;
            display: flex;
            justify-content: space-between;
            position: absolute;
            bottom: 0;
            width: 100%;
            padding-top: .5em;
            border-top: 1px solid #c6cbc4;
        }

        .map-content .map-content-footer-container li {
            display: inline-block;
            font-weight: 300;
            font-size: .65em;
            margin: 0 15px;
        }

        .map-content .map-content-footer-container img,
        .map-content .map-content-footer-container svg {
            height: 30px;
            top: 4px;
            position: relative;
            width: 31px;
            margin: 0;
            margin-right: 5px;
            transition: filter .2s ease-in-out;
        }

        .map-content .map-content-footer-container .active .inverse-hover {
            filter: invert(1);
        }
    </style>
    <div class="grid" style="width: 100%; height: 100%; padding: 0;">
        <div class="map-content" style="width: calc(40% - 1em); padding-left: 0; position: relative; margin: .5em 0 1em 1em;"></div>
        <div style="width: calc(60% - 60px); padding-left: 60px; height: 100%; padding-right: 0;">
            ${BuildingMapSVG}
        </div>
    </div>
  `;
    createSlide({
        center: true,
        // TODO: Something wrong here, instantly goes to the next slide if content not loaded yet
        autoslide: "false",
        wrap: "false",
        html: html,
        background: { color: "#F1F1F1" },
    }, slideMapID);
}
